import { render, staticRenderFns } from "./poll-list.vue?vue&type=template&id=2244a4ca"
import script from "./poll-list.vue?vue&type=script&lang=js"
export * from "./poll-list.vue?vue&type=script&lang=js"
import style0 from "./poll-list.vue?vue&type=style&index=0&id=2244a4ca&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports